import React, { useState } from 'react'
import { FaCodeBranch, FaCircleCheck, FaArrowLeft, FaChevronDown } from 'react-icons/fa6'
import { version, versionDetails } from '../../db/data'
import { AboutContainer } from './styles'
import { useNavigate } from 'react-router-dom'

export default function About() {
  const [currentVer, currentDate] = version.split('_')
  const navigate = useNavigate()
  const [showGid2History, setShowGid2History] = useState(false)

  const entries = Object.entries(versionDetails)
  const gid3Entries = entries.filter(([key]) => key.startsWith('GID 3'))
  const gid2Entries = entries.filter(([key]) => !key.startsWith('GID 3'))

  const latestEntry = gid3Entries[0] || entries[0]
  const otherGid3Entries = gid3Entries.slice(1)

  return (
    <AboutContainer>
      <div className='hero-section'>
        <button className='back-button' onClick={() => navigate(-1)}>
          <FaArrowLeft /> Voltar
        </button>
        <img
          src='https://cdn-icons-png.flaticon.com/512/7988/7988701.png'
          alt='Foguete animado'
          className='hero-gif'
        />
        <h1>Sobre o GID</h1>
        <p className='hero-description'>
          O <strong>Gestão de Informação do Distribuidor</strong> é a plataforma definitiva para
          otimizar a leitura de dados, geração de relatórios de vendas e controle de distribuição.
          Transformamos arquivos brutos em inteligência de negócio.
        </p>
        <div className='current-version-badge'>
          <span className='label'>Versão Atual</span>
          <span className='version'>{currentVer}</span>
          <span className='date'>({currentDate})</span>
        </div>
      </div>

      <div className='changelog-section'>
        <h2>
          <FaCodeBranch size={22} className='icon-blue' /> Histórico de Versões
        </h2>

        {/* Versões do GID 3.0 */}
        <div className='timeline'>
          {latestEntry && (
            <div className='timeline-item latest'>
              <div className='timeline-dot'></div>
              <div className='timeline-content'>
                <div className='version-header'>
                  <span className='version-tag'>{latestEntry[0].split(' - ')[0]}</span>
                  <span className='version-date'>{latestEntry[0].split(' - ')[1]}</span>
                  <span className='new-badge'>NOVO</span>
                </div>
                <ul className='changes-list'>
                  {latestEntry[1].map((change, i) => (
                    <li key={i}>
                      <FaCircleCheck className='check-icon' />
                      <span>{change}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}

          {otherGid3Entries.map(([versionKey, changes], index) => {
            const [ver, date] = versionKey.split(' - ')

            return (
              <div key={index} className='timeline-item'>
                <div className='timeline-dot'></div>
                <div className='timeline-content'>
                  <div className='version-header'>
                    <span className='version-tag'>{ver}</span>
                    <span className='version-date'>{date}</span>
                  </div>
                  <ul className='changes-list'>
                    {changes.map((change, i) => (
                      <li key={i}>
                        <FaCircleCheck className='check-icon' />
                        <span>{change}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            )
          })}
        </div>

        {/* Botão Dropdown / Accordion para Versões Históricas GID 2.0 */}
        {gid2Entries.length > 0 && (
          <div className='history-toggle-container'>
            <button
              type='button'
              className='history-toggle-btn'
              onClick={() => setShowGid2History(!showGid2History)}
            >
              <span>
                {showGid2History
                  ? 'Ocultar Histórico GID 2.0'
                  : 'Ver Versões Anteriores (GID 2.0)'}
              </span>
              <span className='count-badge'>{gid2Entries.length} versões</span>
              <FaChevronDown
                size={12}
                style={{
                  transform: showGid2History ? 'rotate(180deg)' : 'none',
                  transition: 'transform 0.2s ease',
                }}
              />
            </button>
          </div>
        )}

        {/* Lista de Versões Históricas GID 2.0 (Reveladas pelo Dropdown) */}
        {showGid2History && (
          <div className='timeline' style={{ marginTop: '16px' }}>
            {gid2Entries.map(([versionKey, changes], index) => {
              const [ver, date] = versionKey.split(' - ')

              return (
                <div key={index} className='timeline-item'>
                  <div className='timeline-dot'></div>
                  <div className='timeline-content'>
                    <div className='version-header'>
                      <span className='version-tag'>{ver}</span>
                      <span className='version-date'>{date}</span>
                    </div>
                    <ul className='changes-list'>
                      {changes.map((change, i) => (
                        <li key={i}>
                          <FaCircleCheck className='check-icon' />
                          <span>{change}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )
            })}
          </div>
        )}
      </div>
    </AboutContainer>
  )
}
